export function buildObjectPreviewUrl(object) {
  return object?.preview_url || null
}

export function appendPremiumPreviewParam(previewUrl) {
  if (!previewUrl) {
    return null
  }

  const separator = previewUrl.includes('?') ? '&' : '?'
  return `${previewUrl}${separator}premium=1`
}
